import React, { useState, useEffect } from 'react';
import {
  MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn,
  MDBCard, MDBCardBody, MDBTable, MDBTableHead, MDBTableBody
} from 'mdb-react-ui-kit';
import {Row, Col} from 'react-bootstrap'
import '../styles/ActivityLog.css';
import '../styles/Pagination.css';
import { getActivityLog } from '../services/api';
import MainLayout from '../pages/MainLayout';
import Pagination from '../components/Pagination'
import searchIcon from '../assets/icons/Search_24px.svg';

function ActivityLog({ isMobile }) {
  const [activities, setActivities] = useState([]);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [username, setUsername] = useState('');
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const totalPages = Math.ceil(filteredActivities.length / itemsPerPage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getActivityLog();
        const sorted = response.data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setActivities(sorted);
        setFilteredActivities(sorted);
      } catch (err) {
        setError("Error fetching activities");
      }
    };
    fetchData();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const filtered = activities.filter(log =>
      log.username.toLowerCase().includes(username.toLowerCase())
    );
    setFilteredActivities(filtered);
  };

  const formatDateString = (dateStr) => {
    const options = {
      year: 'numeric', month: 'long', day: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true
    };
    return new Date(dateStr).toLocaleDateString('en-US', options).replace(',', '').replace(' at', ',');
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginatedActivities = filteredActivities.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <MainLayout>
      <MDBContainer fluid className=" py-3 activity-log-container">
        <form className="d-flex flex-wrap filter-form mb-4 py-4" onSubmit={handleSearch}>
          <Row className="">
            <Col md={10} sm={8} xs={8} className="position-relative">
              <img
                src={searchIcon}
                alt="Search"
                className="custom-search-icon"
              />

              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Search Username"
                className="custom-search-input rounded-6 ps-5"
              />
            </Col>
            <Col md={2} sm={2} xs={2} className="p-0">
              <button type="submit" className='save-btn'>Search</button>
            </Col>
          </Row>
        </form>

        <MDBCard className="bg-light border rounded-7 w-auto">
          <MDBCardBody className='p-0'>
            <h5 className="card-title py-3 px-4">User</h5>
            <div className='overflow-y-auto'>
            <MDBTable className='overflow-y-auto'>
              <MDBTableHead >
                <tr className='table-header'>
                  <th>Username</th>
                  <th>Action</th>
                  <th>Date</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody >
                {paginatedActivities.map((log, index) => (
                  <tr key={index} className=''>
                    <td className='text-start'>{log.username}</td>
                    <td>{log.apiEndpoint}</td>
                    <td>{formatDateString(log.timestamp)}</td>
                  </tr>
                ))}
              </MDBTableBody>
            </MDBTable>
            </div>
            {/* Desktop layout */}
            <div className='desktop-pagination'>
              <div className="pagination-view d-flex justify-content-between align-items-center mt-3 px-3">
                <div className="custom-dropdown item-per-page">
                  <p className="dropdown-label">Showing:</p>
                  <select className="custom-select" onChange={handleItemsPerPageChange} value={itemsPerPage}>
                    <option value={8}>8 Per page</option>
                    <option value={20}>20 Per page</option>
                    <option value={50}>50 Per page</option>
                    <option value={80}>80 Per page</option>
                    <option value={100}>100 Per page</option>
                  </select>
                </div>

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
                <div className="custom-dropdown current-page">
                  <p className="dropdown-label">Go To Page:</p>
                  <select
                    className="custom-select-page"
                    onChange={(e) => handlePageChange(Number(e.target.value))}
                    value={currentPage}
                  >
                    {[...Array(totalPages)].map((_, index) => (
                      <option key={index + 1} value={index + 1}>
                        {index + 1}
                      </option>
                    ))}
                  </select>
                </div>

              </div>
            </div>

            {/* Mobile layout */}
            <div className='mobile-pagination'>
              <div className="pagination-controls mt-3 px-3">
                <div className="dropdown-row">
                  <div className="dropdown-group">
                    <select className="custom-select-mobile" onChange={handleItemsPerPageChange} value={itemsPerPage}>
                      <option value={8}>8</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={80}>80</option>
                      <option value={100}>100</option>
                    </select>
                    <p className="dropdown-label-mobile">Showing</p>
                  </div>

                  <div className="dropdown-group">
                    <select
                      className="custom-select-mobile"
                      onChange={(e) => handlePageChange(Number(e.target.value))}
                      value={currentPage}
                    >
                      {[...Array(totalPages)].map((_, index) => (
                        <option key={index + 1} value={index + 1}>
                          {index + 1}
                        </option>
                      ))}
                    </select>
                    <p className="dropdown-label-mobile">Go To Page</p>
                  </div>
                </div>

                <div className="pagination-bar">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
              </div>
          </MDBCardBody>
        </MDBCard>
      </MDBContainer>
    </MainLayout>
  );
}

export default ActivityLog;
